export var SubscriptionKind;
(function (SubscriptionKind) {
    SubscriptionKind["ROOT"] = "ROOT";
    SubscriptionKind["NEW"] = "NEW";
    SubscriptionKind["RENEW"] = "RENEW";
    SubscriptionKind["UPGRADE"] = "UPGRADE";
    SubscriptionKind["DOWNGRADE"] = "DOWNGRADE";
})(SubscriptionKind || (SubscriptionKind = {}));
export var SubscriptionFinishedReason;
(function (SubscriptionFinishedReason) {
    SubscriptionFinishedReason["ROOT"] = "ROOT";
    SubscriptionFinishedReason["RENEWED"] = "RENEWED";
    SubscriptionFinishedReason["NON_RENEWED"] = "NON_RENEWED";
    SubscriptionFinishedReason["UPGRADED"] = "UPGRADED";
    SubscriptionFinishedReason["DOWNGRADED"] = "DOWNGRADED";
})(SubscriptionFinishedReason || (SubscriptionFinishedReason = {}));
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["CANCELED"] = "CANCELED";
    SubscriptionStatus["SCHEDULED"] = "SCHEDULED";
    SubscriptionStatus["IN_USE"] = "IN_USE";
    SubscriptionStatus["FINISHED"] = "FINISHED";
    SubscriptionStatus["ERROR"] = "ERROR";
})(SubscriptionStatus || (SubscriptionStatus = {}));
export var SubscriptionPlanPeriods;
(function (SubscriptionPlanPeriods) {
    SubscriptionPlanPeriods["MONTHLY"] = "MONTHLY";
    SubscriptionPlanPeriods["DAILY"] = "DAILY";
    SubscriptionPlanPeriods["WEEKLY"] = "WEEKLY";
    SubscriptionPlanPeriods["YEARLY"] = "YEARLY";
})(SubscriptionPlanPeriods || (SubscriptionPlanPeriods = {}));
export var SubscriptionConsumableFeatures;
(function (SubscriptionConsumableFeatures) {
    SubscriptionConsumableFeatures["RUN_SECONDS"] = "RUN_SECONDS";
    SubscriptionConsumableFeatures["SMS_SENDING"] = "SMS_SENDING";
    SubscriptionConsumableFeatures["CAPTCHA_RESOLVE"] = "CAPTCHA_RESOLVE";
    SubscriptionConsumableFeatures["EMAIL_SENDING"] = "EMAIL_SENDING";
    SubscriptionConsumableFeatures["TEXTRACT_CALL"] = "TEXTRACT_CALL";
    SubscriptionConsumableFeatures["LINKED_DEVICES"] = "LINKED_DEVICES";
})(SubscriptionConsumableFeatures || (SubscriptionConsumableFeatures = {}));
export var SubscriptionConsumablePeriods;
(function (SubscriptionConsumablePeriods) {
    SubscriptionConsumablePeriods["DAILY"] = "DAILY";
    SubscriptionConsumablePeriods["MONTHLY"] = "MONTHLY";
    SubscriptionConsumablePeriods["SUBSCRIPTION"] = "SUBSCRIPTION";
})(SubscriptionConsumablePeriods || (SubscriptionConsumablePeriods = {}));
export var SubscriptionInvoiceStatus;
(function (SubscriptionInvoiceStatus) {
    SubscriptionInvoiceStatus["PENDING"] = "PENDING";
    SubscriptionInvoiceStatus["PAID"] = "PAID";
    SubscriptionInvoiceStatus["CANCELED"] = "CANCELED";
    SubscriptionInvoiceStatus["EXPIRED"] = "EXPIRED";
    SubscriptionInvoiceStatus["REFUNDED"] = "REFUNDED";
})(SubscriptionInvoiceStatus || (SubscriptionInvoiceStatus = {}));
